import { createDynamicThunk } from ".";

/**
 * LIST Internal Error Rca
 */
export const fetchInternalErrorRcaThunk = createDynamicThunk({
  typePrefix: "internalErrorRca/fetchInternalErrorRcaThunk",
  useHandleSearch: true,
});

/**
 * ADD Internal Error Rca
 */
export const submitInternalErrorRcaThunk = createDynamicThunk({
  typePrefix: "internalErrorRca/submitInternalErrorRcaThunk",
  endpoint: "/internal-error-rca",
  method: "POST",
});

/**
 * EDIT Internal Error Rca
 */
export const updateInternalErrorRcaThunk = createDynamicThunk({
  typePrefix: "internalErrorRca/updateInternalErrorRcaThunk",
  endpoint: "/internal-error-rca",
  method: "PUT",
});

/**
 * GET Internal Error Rca Detail
 */
export const fetchInternalErrorRcaDetailThunk = createDynamicThunk({
  typePrefix: "internalErrorRca/fetchDetail",
  endpoint: "/internal-error-rca",
  method: "GET",
});
